import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';

import {
  LJAFullscreenControlDirective,
  LJAGeocoderControlDirective,
  LJAHomeControlDirective,
  LJANavigationControlDirective,
  LJAScaleControlDirective
} from './components/controls';
import { LJAMapComponent } from './components/map';
import { LJAPopupsDirective } from './components/popups';

const components = [
  LJAFullscreenControlDirective,
  LJAGeocoderControlDirective,
  LJAHomeControlDirective,
  LJAMapComponent,
  LJANavigationControlDirective,
  LJAPopupsDirective,
  LJAScaleControlDirective
];

@NgModule({
  declarations: components,
  exports: components
})
export class LJAMapComponentsModule {}
